import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { db } from "../firebaseConfig";
import ProductCard from "./ProductCard";
import { useShopScrollRestore } from "../utils/shopScrollRestore";

const HotDeals = () => {
  const [hotProducts, setHotProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useShopScrollRestore({
    isReady: !loading,
  });

  useEffect(() => {
    db.collection("Products").where("deals", "==", "hot").get()
      .then(snapshot => {
        setHotProducts(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen dark:bg-black bg-white pb-20 pt-24">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="flex items-center gap-3 mb-2">
          <Link
            to="/"
            className="text-gray-500 dark:text-gray-400 hover:text-gray-800 dark:hover:text-white text-sm transition-colors"
          >
            ← Back
          </Link>
        </div>

        <div className="text-center mb-10">
          <h1 className="text-4xl md:text-5xl font-bold dark:text-white text-gray-900">
            🔥 Hot Deals
          </h1>
          <p className="text-gray-500 dark:text-gray-400 mt-3 text-base">
            Exclusive deals you don't want to miss
          </p>
        </div>

        {/* Content */}
        {loading ? (
          <div className="flex justify-center items-center py-24">
            <div className="w-10 h-10 border-4 border-orange-500 border-t-transparent rounded-full animate-spin" />
          </div>
        ) : hotProducts.length === 0 ? (
          <div className="text-center py-24">
            <p className="text-gray-500 dark:text-gray-400 text-lg">
              No hot deals available right now. Check back soon!
            </p>
            <Link
              to="/shop"
              className="mt-6 inline-block bg-orange-500 hover:bg-orange-600 text-white font-semibold px-8 py-3 rounded-full transition-colors"
            >
              Browse Shop
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
            {hotProducts.map((product) => (
              <ProductCard data={product} key={product.id} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default HotDeals;
